import SignInView from '@/modules/auth/components/SignInView'

export default function SignInPage() {
	return <SignInView />
}
